module.exports = __webpack_public_path__ + "static/donga-079aebae9fd588a54a16e8242ec046c2.png";